import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much does apartment renovation cost in Dubai?",
    a: "It depends on the property size, existing condition, scope of work, materials, finishes and level of customization. Send us photos or videos for a rough estimate — the actual price is confirmed after a free site inspection and a detailed, itemised quotation.",
  },
  {
    q: "Can I get a rough renovation estimate from photos?",
    a: "Yes. Send photos or videos of your property on WhatsApp and tell us what you want to renovate. We review the available information and provide a preliminary budget indication. This is a rough estimate — the actual price is determined after a site inspection.",
  },
  {
    q: "Is the site inspection free?",
    a: "Yes. We offer a complimentary site inspection within selected Dubai areas, subject to appointment availability. It allows us to assess actual conditions and prepare an accurate quotation.",
  },
  {
    q: "How is the actual renovation price calculated?",
    a: "After the site inspection we assess the property size, existing condition, scope of work, materials, finishes and customization level, then prepare a detailed itemised quotation — so you know the exact investment before work begins.",
  },
  {
    q: "How long does apartment renovation take?",
    a: "Timelines depend on the scope, materials and approval requirements. Smaller cosmetic upgrades can take a few weeks; complete renovations take longer. We share a specific project timeline after inspecting the property.",
  },
  {
    q: "Do you handle complete home renovation?",
    a: "Yes. We manage complete apartment, home and villa renovation from demolition to final finishing — including kitchens, bathrooms, flooring, ceilings, painting, electrical, plumbing and interior fit-out — under one professional team.",
  },
  {
    q: "Do you renovate kitchens and bathrooms?",
    a: "Yes. Kitchen and bathroom renovation are two of our core services in Dubai, including cabinetry, countertops, tiling, waterproofing, plumbing, electrical, lighting and premium fixtures.",
  },
  {
    q: "Do you handle electrical and plumbing?",
    a: "Yes. We handle full MEP works — electrical, plumbing and AC — including rewiring, sanitary works, light fixtures and coordination with building services.",
  },
  {
    q: "Can one company manage the complete renovation?",
    a: "Yes. That is exactly how we work — one professional team coordinates all trades under a single project, giving you one point of contact from start to handover.",
  },
  {
    q: "Do you provide a detailed quotation before starting?",
    a: "Yes. We do not begin any work without a signed detailed quotation covering scope, materials, timeline and pricing — so there are no surprises later.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 lg:py-28 bg-[#F9F8F6]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12 lg:mb-16">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            Frequently Asked
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 mb-4 leading-[1.1]">
            Renovation Questions Answered
          </h2>
          <p className="text-base lg:text-lg text-neutral-600">
            Everything you need to know before starting your apartment or home renovation in Dubai.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-neutral-200">
              <AccordionTrigger className="text-left font-heading text-lg lg:text-xl font-medium text-neutral-900 hover:text-[#C5A059] py-6 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-600 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
